import React from "react";
import { connect } from "react-redux";
import { postUser } from "../../redux/actions/Users";

class CreateUserPage extends React.Component {
  state = {
    name: null,
    email: null,
    password: null,
    isEnabled: true
  };

  onSubmit(e) {
    e.preventDefault();
    this.setState({
      isEnabled: false
    });
    this.props.postUser(this.state);
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  render() {
    return (
      <div>
        <h1>Create a user</h1>
        <form
          onSubmit={this.onSubmit.bind(this)}
          onChange={this.onChange.bind(this)}
        >
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              autoFocus
              className="form-control"
              maxLength={255}
              id="username"
              name="name"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              className="form-control"
              maxLength={255}
              id="email"
              name="email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              maxLength={60}
              id="password"
              name="password"
              required
            />
          </div>
          <button
            className="btn btn-primary"
            disabled={!this.state.isEnabled}
            type="submit"
          >
            Create
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    postUser: ({ name, email, password }) => {
      dispatch(postUser(name, email, password));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUserPage);



// WEBPACK FOOTER //
// ./src/containers/CreateUserPage/CreateUserPage.js